export function formatDate(date, months) {
  const d = new Date(date);
  return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
}

export function encodeKebabCase(str) {
  if (!str) {
    return '';
  }
  return str.toLowerCase().replace(/\s/g, '-');
}
